// $(window).on("scroll", function() {
//     var s = 400 - Math.min(400, $(document).scrollTop());
//     $(".image-banner__logo img").css("max-width", s);
// });

$(document).ready(function(){
  $(".cart__agecheck").click(function(){
    if ($(this).find('input').is(':checked')) {
      $(this).find('input').prop('checked', false);
    }else{
      $(this).find('input').prop('checked', true);
    }
  });

  if($.cookie('agecheck') == 'true'){
    $(".cart__agecheck input").prop('checked', true);
  }

  $('body').on('click', '.cart-buttons .cart-buttons__btn', function() {
      if ($('#agecheck').is(':checked')) {
        $.cookie('agecheck', 'true', { expires: 1 });
        $(this).submit();
      }else {
        $.removeCookie('agecheck');
        alert("You must confirm that you are over 18 years old.");
        return false;
      }
  });

  // $('body').on('click', '.cart-drawer-subtotal__cta #checkout', function() {
  //     if ($('#cart-drawer__agecheck').is(':checked')) {
  //       $.cookie('agecheck', 'true', { expires: 1 });
  //       $(this).submit();
  //     }else {
  //       $.removeCookie('agecheck');
  //       alert("You must confirm that you are over 18 years old.");
  //       return false;
  //     }
  // });
});